<template>
  <Modal
    class="vote-history"
    v-if="modals.voteHistory && (session.voteHistory || !session.isSpectator)"
    @close="toggleModal('voteHistory')"
  >
    <font-awesome-icon
      @click="clearVoteHistory"
      icon="trash-alt"
      class="clear"
      :title="$t('voteHistory.clearTitle')"
      v-if="session.isSpectator"
    />

    <h3>{{ $t("voteHistory.title") }}</h3>

    <template v-if="!session.isSpectator">
      <div class="options">
        <div class="option" @click="setRecordVoteHistory">
          <font-awesome-icon
            :icon="[
              'fas',
              session.isVoteHistoryAllowed ? 'check-square' : 'square',
            ]"
          />
          {{ $t("voteHistory.accessible") }}
        </div>
        <div class="option" @click="clearVoteHistory">
          <font-awesome-icon icon="trash-alt" />
          {{ $t("voteHistory.clearEveryone") }}
        </div>
      </div>
    </template>
    <section
      class="day-group"
      v-for="(group, groupIndex) in groupedVotes"
      :key="`${group.day}-${groupIndex}`"
    >
      <h4>{{ $t("voteHistory.dayHeading", { number: group.day }) }}</h4>
      <table>
        <thead>
          <tr>
            <td>{{ $t("voteHistory.time") }}</td>
            <td>{{ $t("voteHistory.nominator") }}</td>
            <td>{{ $t("voteHistory.nominee") }}</td>
            <td>{{ $t("voteHistory.type") }}</td>
            <td>{{ $t("voteHistory.votes") }}</td>
            <td>{{ $t("voteHistory.majority") }}</td>
            <td>
              <font-awesome-icon icon="user-friends" />
              {{ $t("voteHistory.voters") }}
            </td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(vote, index) in group.votes" :key="index">
            <td>
              {{ vote.timestamp.getHours().toString().padStart(2, "0") }}:{{
                vote.timestamp.getMinutes().toString().padStart(2, "0")
              }}
            </td>
            <td class="nominator">{{ vote.nominator }}</td>
            <td class="nominee">{{ vote.nominee }}</td>
            <td>{{ voteTypeLabel(vote.type) }}</td>
            <td class="vote-count">
              {{ vote.votes.length }}
              <font-awesome-icon icon="hand-paper" />
            </td>
            <td class="majority">
              {{ vote.majority }}
              <font-awesome-icon
                :icon="[
                  'fas',
                  vote.votes.length >= vote.majority
                    ? 'check-square'
                    : 'square',
                ]"
              />
            </td>
            <td>
              {{ vote.votes.join(", ") }}
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </Modal>
</template>

<script>
import Modal from "./Modal";
import { mapMutations, mapState } from "vuex";

export default {
  components: {
    Modal,
  },
  computed: {
    ...mapState(["session", "modals"]),
    groupedVotes() {
      return this.session.voteHistory.reduce((groups, vote) => {
        const day = vote.day || 1;
        const current = groups[groups.length - 1];
        if (!current || current.day !== day) {
          groups.push({ day, votes: [vote] });
        } else {
          current.votes.push(vote);
        }
        return groups;
      }, []);
    },
  },
  methods: {
    voteTypeLabel(type) {
      if (type === "Exile") return this.$t("voteHistory.exile");
      if (type === "Execution") return this.$t("voteHistory.execution");
      return type;
    },
    clearVoteHistory() {
      this.$store.commit("session/clearVoteHistory");
    },
    setRecordVoteHistory() {
      this.$store.commit(
        "session/setVoteHistoryAllowed",
        !this.session.isVoteHistoryAllowed,
      );

      if (this.session.isVoteHistoryAllowed) {
        // Enable vote watching if vote history is re-enabled.
        this.$store.commit("session/setVoteWatchingAllowed", true);
      }
    },
    ...mapMutations(["toggleModal"]),
  },
};
</script>

<style lang="scss" scoped>
@import "../../vars.scss";

.clear {
  position: absolute;
  left: 20px;
  top: 15px;
  cursor: pointer;
  &:hover {
    color: red;
  }
}

.options {
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
  align-content: center;
}

.option {
  color: white;
  text-decoration: none;
  margin: 0 15px;
  &:hover {
    color: red;
    cursor: pointer;
  }
}

h3 {
  margin: 0 40px 0 10px;
  svg {
    vertical-align: middle;
  }
}

table {
  border-spacing: 10px 0;
  margin-left: auto;
  margin-right: auto;
}

.day-group {
  margin-top: 18px;

  h4 {
    margin: 0 0 8px;
    padding: 5px 10px;
    color: #ffd15c;
    border-bottom: 1px solid rgba(255, 209, 92, 0.7);
    font-family: PiratesBay, sans-serif;
    letter-spacing: 1px;
  }
}

thead td {
  font-weight: bold;
  border-bottom: 1px solid white;
  text-align: center;
  padding: 0 3px;
}

tbody {
  .nominator {
    color: $townsfolk;
  }
  .nominee {
    color: $demon;
  }
  .vote-count,
  .majority {
    text-align: center;
  }
}
</style>
